import { getContext } from '@/context';
import { MINIAPP_PACKAGE_ID } from '@/consts/configs';
import ANALYTICS_EVENT_NAMES from '@/consts/analytics';

/**
 * Sends a content_try analytics event.
 * Fires when user adds content to canvas (e.g., "Add to Canvas" button).
 */
const sendContentTryAnalytics = () => {
  try {
    const params = {
      miniapp_package_id: MINIAPP_PACKAGE_ID,
    };

    getContext().handlers.sendAnalytics({
      eventName: ANALYTICS_EVENT_NAMES.CONTENT_TRY,
      params,
    });
  } catch {
    // Failed to send analytics
  }
};

export default sendContentTryAnalytics;
